
export function mapResponseInterceptor(response) {
    if (response.data) {
        return response.data
    }
    return response;
}